import { i18n } from "../../../i18n";

const fb = require('../../../config/firebase.js')

import { fbFunctions } from "@/config/firebase";

const state = () => ({
    feedPortlets: {},
    feedPortletsCount: 0,
    feedPortletsTotalLoaded: 0,
    feedLoaded: false,
    feedMoreDataAvailable: true,
    feedAlreadyShawnNoMorePopup: false,
    feedUserId: '',
    FEED_LIMIT: 2,
    FEED_LOAD_MORE_LIMIT: 5,
})

const getters = {}

const actions = {
    fetchUserFeed({ commit, state }, payload) {
        commit('setResetFeed');
        commit('setFeedUserId', payload.userId);
        if(payload.shouldReset) commit('setFeedPortletsCount', 0);
        fb.usersCollection.doc(payload.userId)
            .collection('user_feed')
            .where('local_user_id', '==', payload.userId)
            .limit(state.FEED_LIMIT)
            .orderBy('date', 'desc')
            .get()
            .then((docSnaps) => {
                docSnaps.forEach(function (doc) {
                    commit('setFeedPortlets', {
                        'id': doc.id,
                        'data': doc.data()
                    })
                    fb.usersCollection.doc(doc.data().remote_user_id)
                        .get()
                        .then((user) => {
                            commit('setFeedPortletsUserInfos', {
                               'id': doc.id,
                               'userInfos': user.data()
                            })
                            commit('setFeedPortletsCount', state.feedPortletsCount += 1)
                        })
                        .finally(() => {
                            if(docSnaps.size === state.feedPortletsCount) commit('setFeedLoaded', true);
                            if(payload.isInLoadMoreContext) {
                                if(state.FEED_LIMIT > docSnaps.size) {
                                    if(!state.alreadyShawnNoMorePoup) {
                                        Swal.fire(
                                            i18n.t("feed.main.no_more_feed_title"),
                                            i18n.t("feed.main.no_more_feed_subtitle"),
                                            "warning"
                                        );
                                    }
                                    commit('setAlreadyShawnNoMorePopup', true);
                                }
                            }
                        });
                })
            });
    },
    fetchMoreFeed({ commit, state }) {
        commit('setFeedLoaded', false);
        commit('setFeedLimit', state.FEED_LIMIT + state.FEED_LOAD_MORE_LIMIT);
        commit('setFeedPortletsCount', state.feedPortletsCount + state.FEED_LIMIT);
        this.dispatch('feed/fetchUserFeed', {
            'userId': state.feedUserId,
            'shouldReset': true,
            'isInLoadMoreContext': true,
        });
    },
    fetchUserEmail({ commit, state }, payload) {
        let saveProfileInfos = fbFunctions.httpsCallable('api');
        Swal.fire(
            i18n.t("feed.portlet.modal_fetch_in_progress_title"),
            i18n.t("feed.portlet.modal_fetch_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'retrieveUserEmail',
            parameters: {
                'userId': payload.userId,
            }
        })
        .then(function(result) {
            if(result.data.code === "SUCCESS_USER_ACCEPTED_TO_SHOW_EMAIL") {
                swal.fire(
                    i18n.t("feed.portlet.modal_fetch_email_success_title"),
                    i18n.t("feed.portlet.modal_fetch_email_success_content", {'email': result.data.email }),
                    "success"
                );
            }
            else if(result.data.code === "SUCCESS_USER_DONT_WANT_TO_SHOW_EMAIL") {
                swal.fire(
                    i18n.t("feed.portlet.modal_fetch_email_user_dont_show_title"),
                    i18n.t("feed.portlet.modal_fetch_email_user_dont_show_content"),
                    "error"
                );
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    "error"
                )
            }
        })
        .catch((e) => {
            console.log(e);
            swal.fire(
                i18n.t("administration.admin.global.modal_generic_error_title"),
                i18n.t("administration.admin.global.modal_generic_error_title"),
                "error"
            )
        });
    }
}

const mutations = {
    setFeedLoaded(state, val) {
        state.feedLoaded = val
    },
    setFeedPortlets(state, val) {
        state.feedPortlets[val.id] = val.data;
    },
    setFeedPortletsUserInfos(state, val) {
        state.feedPortlets[val.id].userInfos = val.userInfos;
    },
    setFeedPortletsCount(state, val) {
        state.feedPortletsCount = val;
    },
    setAlreadyShawnNoMorePopup(state, val) {
        state.feedAlreadyShawnNoMorePopup = val;
    },
    setFeedLimit(state, val) {
        state.FEED_LIMIT = val;
    },
    setFeedUserId(state, val) {
        state.feedUserId = val;
    },
    setResetFeed(state, val) {
        state.feedPortlets = {};
        state.feedPortletLoaded = {};
        state.feedPortletsCount = 0;
        state.feedPortletsTotalLoaded = 0;
        state.feedLoaded = false;
        state.feedMoreDataAvailable = true;
        state.feedAlreadyShawnNoMorePopup = false;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/stores/modules/pages/feed.js